import React, { Component } from 'react';

import Select from "react-select";
import UserStore from "../stores/UserStore";


class Band extends Component {
  render() {
    return (
      <div>
        <div className="form-group">
          <label className="control-label" htmlFor="name">Channel #{this.props.channel+1} frequency (in MHz)</label>
          <input className="form-control" id="name" type="number" min="0" step="0.000001" value={this.props.freqency} onChange={this.props.onChange} />
        </div>
      </div>
    );
  }
}


class AddShare extends Component {
  constructor() {
    super();

    this.state = {
      initialOptions: [],
      username: "",
      admin: false,
    };

    this.onAutocompleteSelect = this.onAutocompleteSelect.bind(this);
    this.onAutocomplete = this.onAutocomplete.bind(this);
    this.setInitialOptions = this.setInitialOptions.bind(this);
    this.handleAddShare = this.handleAddShare.bind(this);
  }

  setInitialOptions() {
    if (this.state.initialOptions.length === 0) {
      UserStore.getAll("", 999, 0, (totalCount, users) => {
        const options = users.map((user, i) => {
          return {
            value: user.username,
            label: user.username,
          };
        });

        this.setState({
          initialOptions: options,
        });
      });
    }
  }

  onAutocompleteSelect(val) {
    this.setState({username: val.label});
  }

  onAutocomplete(input, callbackFunc) {
    UserStore.getAll(input, 999, 0, (totalCount, users) => {
      const options = users.map((user, i) => {
        return {
          value: user.username,
          label: user.username,
      }}); 

      callbackFunc(null, {
        options: options,
        complete: true,
      });
    }); 
  }
  
  onChange(field, e) {
    let admin = this.state.admin;

    if (e.target.type === "checkbox") {
      admin = e.target.checked;
    }
    
    this.setState({admin: admin});
  };  

  handleAddShare(e) {
    e.preventDefault();

    if (this.state.username === '') {
      alert("Please select a user to share");
      return;
    }

    this.props.addShare(this.state.username, this.state.admin);
  }

  render() {
    return(
      <div>  
        <div className="btn-group pull-right" role="group" aria-label="...">
          <a onClick={this.handleAddShare}><button type="button" className="btn btn-info">Add</button></a>
        </div>
        <hr/>
        <div className="form-group">
          <label className="control-label" htmlFor="name">Username</label>
          <Select.Async name="username" onOpen={this.setInitialOptions} options={this.state.initialOptions} loadOptions={this.onAutocomplete} value={this.state.username} onChange={this.onAutocompleteSelect} clearable={false} autoload={false} />
        </div>
        <div className="form-group">
          <label className="control-label">Admin</label>
          <div className="checkbox">
            <label>
              <input type="checkbox" name="admin" id="admin" checked={this.state.admin} onChange={this.onChange.bind(this, 'admin')} /> Is band admin
            </label>
          </div>
          <p className="help-block">
            When checked, the user will be assigned admin permissions within the context of the band.
          </p>
        </div> 
      </div>      
    );
  }
}


class BandUserRow extends Component {
  handleRemoveShare(e) {
    e.preventDefault();

    this.props.removeShare(this.props.index);
  }

  onChange(e) {
     if (e.target.type === "checkbox") {
      this.props.modifyCheck(this.props.index, e.target.checked);
    }
  };

  render() {
    return(
      <tr>
        <td>{this.props.username}</td>
        <td>
          <input type="checkbox" id={this.props.index} checked={this.props.admin} onChange={this.onChange.bind(this)} />
        </td>
        <td><a href="" onClick={this.handleRemoveShare.bind(this)}>remove</a></td>
      </tr>
    )
  }
}

class BandForm extends Component {
  constructor() {
    super();

    this.state = {
      activeTab: "network-settings",

      band: {
        name: "",
        txpower: 20,
        rx2Dr: 0,
        rx2Frequency: 0.0,
        frequencyUp: [],
        frequencyDown: [],
        share: [],
      },

      disabled: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.addShare = this.addShare.bind(this);
    this.removeShare = this.removeShare.bind(this);
    
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      band: nextProps.band,
      disabled: nextProps.disabled,
    }); 
  }

  onChange(field, e) {
    let band = this.state.band;
    let user = this.state.user;
    if (e.target.type === "number") {
      band[field] = parseInt(e.target.value, 10);
    } else if (e.target.type === "checkbox") {
      user[field] = e.target.checked;
    } else {
      band[field] = e.target.value;
    }
    this.setState({band: band});
  };

  onFloatChange(field, e) {
    let band = this.state.band;
    band[field] = parseFloat(e.target.value);
    this.setState({band: band});
  };

  onFrequencyUpChange(i, e) {
    let band = this.state.band;
    band.frequencyUp[i] = parseFloat(e.target.value);
    band.frequencyDown[i] = band.frequencyUp[i];
    this.setState({band: band});
  }


  handleSubmit(e) {
    e.preventDefault();
    this.props.onSubmit(this.state.band);
  }

  changeTab(e) {
    e.preventDefault();
    this.setState({
      activeTab: e.target.getAttribute('aria-controls'),
    });
  }

  addShare(username, admin) {
    let band = this.state.band;
    for (var i = 0; i < band.share.length; i++) {
      if (band.share[i].name === username) {
        return;
      }
    }
    band.share.push({name:username, admin:admin});
    this.setState({band : band});
  }

  removeShare(index) {
    let band = this.state.band;
    band.share.splice(index, 1);
    this.setState({band : band});   
  }

  modifyCheck(index, checked) {
    let band = this.state.band;
    band.share[index].admin = checked;
    this.setState({band : band});  
  }

  render() {
    let chu = this.state.band.frequencyUp;
    for(var i = 0; 8 - chu.length; i++) {
      chu.push(0);
    }

    let chd = this.state.band.frequencyDown;
    for(i = 0; 8 - chd.length; i++) {
      chd.push(0);
    }

    const ChannelsUp = this.state.band.frequencyUp.map((freq, i) => <Band key={i} isup={true} channel={i} freqency={freq} onChange={this.onFrequencyUpChange.bind(this, i)} />); 

    const BandUserRows = this.state.band.share.map((item, i) => <BandUserRow username={item.name} admin={item.admin} index={i} removeShare={this.removeShare} modifyCheck={this.modifyCheck.bind(this)} />);

    return(
      <div>
        <ul className="nav nav-tabs">
          <li role="presentation" className={(this.state.activeTab === "network-settings" ? 'active' : '')}><a onClick={this.changeTab} href="#network-settings" aria-controls="network-settings">Network settings</a></li>
          <li role="presentation" className={(this.state.activeTab === "share" ? 'active' : '')}><a onClick={this.changeTab} href="#share" aria-controls="share">Share</a></li>
        </ul>
        <hr />

        <form onSubmit={this.handleSubmit}>
          <fieldset disabled={this.state.disabled}>
              
            <div className={(this.state.activeTab === "network-settings" ? '' : 'hidden')}>
              <div className="form-group">
                <label className="control-label" htmlFor="name">Band name</label>
                <input className="form-control" id="name" type="text" required value={this.state.band.name || ''} onChange={this.onChange.bind(this, 'name')} />
              </div>
              <div className="form-group">
                <label className="control-label" htmlFor="txpower">Tx Power(dBm)</label>
                <input className="form-control" id="txpower" type="number" required value={this.state.band.txpower || ''} onChange={this.onChange.bind(this, 'txpower')} />
              </div>
              <div className="form-group">
                <label className="control-label" htmlFor="rx2dr">Rx2 Data Rate</label>
                <input className="form-control" id="rx2dr" type="number" min="0" required value={this.state.band.rx2Dr || '0'} onChange={this.onChange.bind(this, 'rx2Dr')} />
              </div>
              <div className="form-group">
                <label className="control-label" htmlFor="rx2frequency">Rx2 Frequency(MHz)</label>
                <input className="form-control" id="rx2frequency" type="number" min="0" step="0.000001" required value={this.state.band.rx2Frequency || ''} onChange={this.onFloatChange.bind(this, 'rx2Frequency')} />
              </div>
              <hr />
              {ChannelsUp}
            </div>


            <div className={(this.state.activeTab === "share" ? '' : 'hidden')}>
              
              <div className="panel panel-default">
                <div className="panel-body">  
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Username</th>
                        <th>Is band admin</th>
                        <th>Operation</th>
                      </tr>
                    </thead>
                    <tbody>
                      {BandUserRows}
                    </tbody>
                  </table>
                </div>
              </div>

              <AddShare addShare={this.addShare} />

            </div>

            <hr />
            <button type="submit" className="btn btn-primary pull-right">Submit</button>
          </fieldset>
        </form>
      </div>
    );
  }
}

export default BandForm;



// WEBPACK FOOTER //
// ./src/components/BandForm.js